import { useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import { useRouteError } from "react-router-dom";
import * as Sentry from "@sentry/react";

import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import NavBar from "../NavBar/NavBar";

const Error = ({ message }) => {
    const error = useRouteError();
    const errorMessage = error?.message || message || "An unexpected error occurred.";

    useEffect(() => {
        Sentry.captureException(errorMessage);
    }, [errorMessage]);
    
    return (
        <div>
            {error ? <Header /> : null}
            {error ? <NavBar /> : null}
            <Box sx={{textAlign: 'center', height: '80vh', mt: '2rem'}}>
                <Typography variant="h4">{errorMessage}</Typography>
                <Button href='/' variant="contained" sx={{marginTop: 2}}>Go Home</Button>
            </Box>
            {error ? <Footer /> : null}
        </div>
        
    )
};

export default Error;